import { render, staticRenderFns } from "./ProductRating.vue?vue&type=template&id=58fb3cf1&"
import script from "./ProductRating.vue?vue&type=script&lang=js&"
export * from "./ProductRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58fb3cf1')) {
      api.createRecord('58fb3cf1', component.options)
    } else {
      api.reload('58fb3cf1', component.options)
    }
    module.hot.accept("./ProductRating.vue?vue&type=template&id=58fb3cf1&", function () {
      api.rerender('58fb3cf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ProductRating.vue"
export default component.exports